import { LOCALE } from './i18n.ts';

const clock = new Intl.DateTimeFormat(LOCALE, { hour: '2-digit', minute: '2-digit' });
const clockSeconds = new Intl.DateTimeFormat(LOCALE, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
const shortDate = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'short' });
const fullDate = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
const barDate = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'short', year: 'numeric', weekday: 'long' });
const monthYear = new Intl.DateTimeFormat(LOCALE, { month: 'long', year: 'numeric' });
const weekdayShort = new Intl.DateTimeFormat(LOCALE, { weekday: 'short' });
const weekdayLong = new Intl.DateTimeFormat(LOCALE, { weekday: 'long' });
const fileDate = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' });

/** HH:mm, or HH:mm:ss when the user asked for seconds. */
export const formatClock = (date: Date, seconds = false) => (seconds ? clockSeconds : clock).format(date);
export const formatShortDate = (date: Date) => shortDate.format(date);
export const formatFullDate = (date: Date) => fullDate.format(date);
export const formatBarDate = (date: Date) => barDate.format(date);
export const formatMonthYear = (date: Date) => monthYear.format(date);
export const formatWeekdayShort = (date: Date) => weekdayShort.format(date);
export const formatWeekdayLong = (date: Date) => weekdayLong.format(date);
export const formatFileDate = (iso: string) => fileDate.format(new Date(iso));

const byteUnits = ['byte', 'kilobyte', 'megabyte', 'gigabyte'] as const;
export function formatBytes(bytes: number): string {
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < byteUnits.length - 1) {
    value /= 1024;
    unit++;
  }
  return new Intl.NumberFormat(LOCALE, {
    style: 'unit',
    unit: byteUnits[unit],
    unitDisplay: 'short',
    maximumFractionDigits: unit === 0 ? 0 : 1,
  }).format(value);
}

/** Local calendar date as YYYY-MM-DD, independent of the UTC offset. */
export function isoDay(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseIsoDay(value: string): Date {
  const [y, m, d] = value.split('-').map(Number);
  return new Date(y!, m! - 1, d!);
}
